import { OldPortfolio } from './old-portfolio.interface';

export class Engagement {
	public uniqueId: string;
	public advisorName: string;
	public asOfDate: Date;
	public dateLastShared: Date;
	public lastModifiedDate: Date;
	public portfolios: Array<OldPortfolio>;
	public emailAddress: string;
	public firmName: string;
	public portfolioStrategist: string;
	public sharedAdvisorEmailList: string;
	public title: string;
	public userEmail: string;
	public type: string;
	public finalFlag: string;
	public pdfDataPortfolioDate: string;
	public pdfDataAsOfDate: string;
	public pdfDateCreated: string;
	public displayName?: string;
}
